<template>
  <div class="rateplan-picker">
    <div class="rateplan-picker-row">
      <div class="form-group rateplan-picker-field">
        <label class="rateplan-picker-label" :for="inputId">{{ _('Rate plan') }}</label>
        <select :id="inputId" class="form-control" :value="selectedId === null || selectedId === undefined ? '' : String(selectedId)" v-on:change="$emit('select', $event.target.value)">
          <option v-for="plan in plans" :key="'rp-' + plan.id" :value="String(plan.id)">{{ optionLabel(plan) }}</option>
        </select>
      </div>
      <div class="btn-group rateplan-picker-actions">
        <button type="button" class="btn btn-default" :disabled="!selectedPlan || isSelectedDefault" :title="_('Default rate')" v-on:click="$emit('set-default')">
          <i class="fa fa-fw fa-star" :class="{ 'text-warning': isSelectedDefault }"></i>
        </button>
        <button type="button" class="btn btn-default" :disabled="!selectedPlan" :title="_('Edit rate plan')" v-on:click="$emit('edit')">
          <i class="fa fa-fw fa-pencil"></i>
        </button>
        <button type="button" class="btn btn-default" :title="_('Add rate plan')" v-on:click="$emit('add')">
          <i class="fa fa-fw fa-plus"></i>
        </button>
      </div>
      <button v-if="help" type="button" class="btn btn-link rateplan-picker-help-btn" :title="_('Help')" :aria-expanded="showHelp ? 'true' : 'false'" v-on:click="showHelp = !showHelp">
        <i class="fa fa-fw fa-question-circle"></i>
      </button>
    </div>
    <a v-if="summaryParts.length" href="javascript:;" class="rateplan-picker-summary" :title="_('Edit rate plan')" v-on:click="$emit('edit')">
      <template v-if="Array.isArray(summary)"><span v-for="(part, i) in summaryParts" :key="'rps-' + i" class="rateplan-picker-chip">{{ part }}</span></template>
      <template v-else>{{ summary }}</template>
    </a>
    <p v-if="help && showHelp" class="help-block rateplan-picker-help">{{ help }}</p>
  </div>
</template>

<script>
// Rate plan selector of the price calendars: a dropdown with default / edit / add buttons and a
// summary of the selected plan (a line of text, or chips). Editing (and deleting) happens in the parent's plan dialog.
export default {
  props: {
    plans: { type: Array, default: () => [] },
    selectedId: { type: [String, Number], default: null },
    optionLabel: { type: Function, default: plan => plan.title },
    summary: { type: [String, Array], default: '' }, // A line of text, or a list of settings shown as chips
    help: { type: String, default: '' },
    inputId: { type: String, default: 'rateplan-picker' }
  },
  emits: ['select', 'set-default', 'edit', 'add'],
  data () {
    return {
      showHelp: false
    }
  },
  computed: {
    selectedPlan () {
      return this.plans.find(p => String(p.id) === String(this.selectedId)) || null
    },
    isSelectedDefault () {
      return !!(this.selectedPlan && parseInt(this.selectedPlan.is_default))
    },
    summaryParts () {
      return (Array.isArray(this.summary) ? this.summary : [this.summary]).filter(Boolean)
    }
  }
}
</script>

<style scoped>
.rateplan-picker-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px
}
.rateplan-picker-field {
  position: relative;
  display: flex;
  align-items: center;
  margin: 0
}
.rateplan-picker-label { /* An eyebrow on the select's top border */
  position: absolute;
  left: 8px;
  top: 0;
  z-index: 1;
  max-width: calc(100% - 28px);
  margin: 0;
  padding: 0 4px;
  overflow: hidden;
  background: #f5f5f5;
  color: #777;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform: translateY(-50%)
}
.rateplan-picker-field:focus-within .rateplan-picker-label {
  color: #337ab7
}
.rateplan-picker-field .form-control {
  display: inline-block;
  width: auto;
  min-width: 200px;
  max-width: 320px
}
.rateplan-picker-actions {
  display: flex;
  flex-wrap: nowrap
}
.rateplan-picker-help-btn {
  padding-left: 2px;
  padding-right: 2px
}
.rateplan-picker-summary {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #777
}
.rateplan-picker-summary:hover,
.rateplan-picker-summary:focus {
  color: #337ab7;
  text-decoration: none
}
.rateplan-picker-chip {
  display: inline-block;
  margin: 2px 6px 0 0;
  padding: 1px 8px;
  border: 1px solid #d5d9dc;
  border-radius: 10px;
  background: #fff; /* Stands out from the toolbar's #f5f5f5 */
  color: #555;
  white-space: nowrap
}
.rateplan-picker-summary:hover .rateplan-picker-chip,
.rateplan-picker-summary:focus .rateplan-picker-chip {
  color: #337ab7
}
.rateplan-picker-help {
  max-width: 640px;
  margin: 6px 0 0
}
@container pricing-calendar (max-width: 680px) {
  .rateplan-picker-field .form-control {
    min-width: 0;
    width: 148px
  }
}
</style>
